export default __webpack_public_path__ + "static/media/natural-language-processing.f5473bbf.png";